import { SideModal } from 'shared/ui/SideModal';
import { useEffect } from 'react';
import { useHolidaySchedule } from 'entities/profile';
import { HOLYDAY_SCHEDULE_QUERY_KEY } from 'pages/ContractorCampaigns';
import { useModalUrl } from 'shared/lib/hooks';

import { HolidayScheduleModalBody } from './HolidayScheduleModalBody';
import { formatHolidayData } from './lib';
import { useHolidaysActions, useHolidaysValues } from './store/store';

export function HolidayScheduleModal() {
  const getHolidayScheduleQuery = useHolidaySchedule();
  const { setFullState, setInitialState } = useHolidaysActions();
  const holidays = useHolidaysValues();

  const holidaySchedule = getHolidayScheduleQuery.data?.data.holidays;
  const formattedHolidays = holidaySchedule ? formatHolidayData(holidaySchedule) : null;

  useEffect(() => {
    if (!holidays) {
      setFullState(formattedHolidays);
    }
  }, [formattedHolidays, holidays]);

  useEffect(() => {
    return () => {
      getHolidayScheduleQuery.remove();
      setInitialState();
    };
  }, []);

  useModalUrl({ modalId: 1, query: getHolidayScheduleQuery, modalKey: HOLYDAY_SCHEDULE_QUERY_KEY });

  return (
    <SideModal isLoading={getHolidayScheduleQuery.isFetching}>{holidays && <HolidayScheduleModalBody />}</SideModal>
  );
}
